import React from 'react';
import { connect } from "react-redux";
import WrapperStyles from '@bit/xseed.ui-components.wrapper-styles';
import Globalstyle from '@bit/xseed.ui-components.globalstyle';
import Container from '@bit/xseed.ui-components.container';

import QuotersList from './QuotersList';
import ChangePassword from './Common/Login/ChangePassword';
import AutosSOA from './Quoters/AutosSOA';
import AutosStandard from './Quoters/AutosStandard';
import Pyme from './Quoters/Pyme';
import Yates from './Quoters/Yates';
import GtiaAlquiler from './Quoters/GtiaAlquiler';
import Hogar from './Quoters/Hogar';
import APersonales from './Quoters/AP';
import Salud from './Quoters/Salud';
import { setOptionsValue } from "../actions";

import { quoters } from '../ecosystem.config';

const isProd = process.env.NODE_ENV === "production";

const App = (props) => {
  const {
    setOptionsValue,
    changePasswordAction
  } = props;

  const quoterUrl = window.location.pathname.split('/').filter(seg => seg.length);
  let quoter = '';
  if(quoterUrl.length) quoter = decodeURIComponent(quoterUrl.pop());
  setOptionsValue('quoter', quoter);

  return (
    <WrapperStyles>
      <Container>
        <GtiaAlquiler />
        {/* {quoter === ''                         && <QuotersList /> }
        {quoter === 'cotizadores'              && <QuotersList /> }
        {quoter === 'cambiar_contraseña'       && <ChangePassword />}
        {quoter === quoters.AUTOSSOA.key       && <AutosSOA />}
        {quoter === quoters.AUTOSSTANDARD.key  && <AutosStandard economic={false} />}
        {quoter === quoters.AUTOSECONOMICO.key && <AutosStandard economic={true} />}
        {quoter === quoters.PYME.key           && <Pyme productCode={0} />}
        {quoter === quoters.PYMEFARMACIA.key   && <Pyme productCode={1} />}
        {quoter === quoters.YATES.key          && <Yates />}
        {quoter === quoters.GTIAALQUILER.key   && <GtiaAlquiler />}
        {quoter === quoters.HOGAR.key          && <Hogar />}
        {quoter === quoters.APERSONALES.key    && <APersonales />}
        {quoter === quoters.SALUD.key          && <Salud />} */}
      </Container>
    </WrapperStyles>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setOptionsValue: (type, value) => {
      dispatch(setOptionsValue(type, value));
    },
  };
};

export default connect(null, mapDispatchToProps)(App);
